module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAMRJREFUKFOVUjESgjAQ3KtIp0/xB+IPtKVRnkBF8oLQ8QSxgVKfAD/gKdhBdc5lCIMzMkKqncvuziZ7hNmx1t6I6ArgMI5bIirSNH14GgnI83w/DMMTQDg3mOE6CIJLkiSdE1hrayI6LpD9uNZan2iMcf9DdtfMHItgjbsXNJRlWQdgF0WROKCqKixhAN2XQGzKsnSCXxjAe3ukzY9e+63M3Bhjwqm4vu9fS10IWSl1norzHUg8ALIebjWYuQVQGGMKz/kA9xJrsJB7jzEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_moreD.png
// module id = kvVR
// module chunks = 1